var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ROLL_PREFIX = 'TR_';
var ROLL_E_PREFIX = 'TRE_';
var FOX_PREFIX = 'TF_';
var BLUEMARK_PREFIX = 'BM_';
var CARD_PREFIX = 'TC_';
var PRIME2_PREFIX = 'TMP2_';
var TOPMARK_PREFIX = 'TM_';
export var thermomarkGoId = 19;
export var thermomarkRollEId = 20;
export var thermomarkRollId = 17;
export var thermomarkCardId = 16;
var SHEET_IMAGEABLE_AREA = { l: 0, t: 0, r: 104, b: 140 };
var SHEET_PRINTING_OFFSETS = { l: 5.5, t: 0.0, r: -5.5, b: -24 };
var ZERO_BOX = { l: 0.0, t: 0.0, r: 0.0, b: 0.0 };
export var convert = function (_a) {
    // console.info('category: ', category);
    // console.info('pageBox: ', pageBox);
    // console.info('pageMargin: ', pageMargin);
    // console.info('shieldsBox: ', shieldsBox);
    // console.info('originalInputDirection: ', originalInputDirection);
    var category = _a.category, pageBox = _a.pageBox, pageMargin = _a.pageMargin, shieldsBox = _a.shieldsBox, originalInputDirection = _a.originalInputDirection, printerId = _a.printerId, printerModels = _a.printerModels;
    var inputDirection = originalInputDirection; //TODO check if correct
    var debug_label_offset = null;
    var printing_offsets = __assign({}, ZERO_BOX);
    var pageArea = __assign({}, pageBox);
    var printArea = __assign({}, ZERO_BOX);
    switch (category) {
        case 'Endless':
        case 'Diecut':
            if (printerId === thermomarkGoId) { //if (fullName.startsWith(FOX_PREFIX)) {
                printArea = __assign({}, shieldsBox);
                printing_offsets = boxMinusBox(shieldsBox, pageBox);
                if (pageMargin) {
                    debug_label_offset = {
                        l: pageMargin.left,
                        t: pageMargin.top,
                        r: pageMargin.right,
                        b: pageMargin.bottom,
                    };
                    printing_offsets.l = printing_offsets.l - debug_label_offset.l;
                    printing_offsets.t = printing_offsets.t - debug_label_offset.t;
                    printing_offsets.r = printing_offsets.r + debug_label_offset.r;
                    printing_offsets.b = printing_offsets.b + debug_label_offset.b;
                }
                else {
                    debug_label_offset = __assign({}, ZERO_BOX);
                }
            }
            else if (printerId === thermomarkRollId || printerId === thermomarkRollEId) { //} else if (fullName.startsWith(ROLL_PREFIX) || fullName.startsWith(ROLL_E_PREFIX)) {
                if (category == 'Endless') {
                    printArea = __assign({}, shieldsBox);
                }
                else {
                    printArea = __assign({}, pageBox);
                }
                printing_offsets = __assign({}, ZERO_BOX);
                //TODO check in matfile.ts and uncomment this
                // if (symmetricalVerticalOffset != 0) {
                //   printing_offsets.t = printing_offsets.t + symmetricalVerticalOffset
                //   printing_offsets.b = printing_offsets.b - symmetricalVerticalOffset
                // }
            }
            break;
        case 'Other':
            printing_offsets = rotateOffset(inputDirection, SHEET_PRINTING_OFFSETS);
            printArea = rotateArea(inputDirection, SHEET_IMAGEABLE_AREA);
            break;
        default: //include all categories for 'Strip', like 'UC'/'UCT'/'US'
            printing_offsets = __assign({}, ZERO_BOX);
            printArea = __assign({}, pageBox);
            break;
    }
    return {
        canvas_color: '',
        printing_offsets: printing_offsets,
        print_area: printArea,
        page_area: pageArea,
        debug_label_offset: debug_label_offset !== null && debug_label_offset !== void 0 ? debug_label_offset : __assign({}, ZERO_BOX),
        color_output_mode: 'MONO',
        transforms: originalInputDirection == 90 ?
            [{
                    action: 'ROTATE_CW90',
                    offset_central_point: {
                        x: 0.00,
                        y: 0.00,
                    },
                }] : [],
        debug_input_direction: originalInputDirection,
        printer_models: printerModels,
    };
};
var rotateOffset = function (angle, box) {
    return rotate(ZERO_BOX, angle, box);
};
var rotateArea = function (angle, box) {
    return rotate(box, angle, box);
};
var rotate = function (world, angle, inBox) {
    if (angle == 0) {
        return inBox;
    }
    else {
        var box = __assign({}, ZERO_BOX);
        var width = calc_width(world);
        var height = calc_height(world);
        if (angle == 180) {
            // (-x; -y)
            // L;T
            box.l = -inBox.r + width;
            box.t = -inBox.b + height;
            // R;B
            box.r = -inBox.l + width;
            box.b = -inBox.t + height;
        }
        else if (angle == 270) {
            // (-y; x)
            // L;T
            box.r = -inBox.t + height;
            box.t = inBox.l;
            // R;B
            box.l = -inBox.b + height;
            box.b = inBox.r;
        }
        else if (angle == 90) {
            // (y; -x)
            // L;T
            box.l = inBox.t;
            box.t = -inBox.r + width;
            // R;B
            box.r = inBox.b;
            box.b = -inBox.l + width;
        }
        else {
            console.error('Wrong inputDirection value:' + angle);
        }
        return box;
    }
};
var boxMinusBox = function (a, b) {
    return {
        l: a.l - b.l,
        t: a.t - b.t,
        r: a.r - b.r,
        b: a.b - b.b,
    };
};
var calc_width = function (box) {
    return box.r - box.l;
};
var calc_height = function (box) {
    return box.b - box.t;
};
